<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  }
})

const height = computed(() => props.height ? props.height : 41)
const width = computed(() => height.value * 52 / 61)

</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 52 61" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1756_2012)">
      <path d="M0 7.12427H51.9043V31.3194C51.9043 37.9785 48.3343 44.1321 42.5393 47.4619L25.9523 56.9931L9.36507 47.4619C3.56989 44.1321 5.94889e-06 37.9785 5.94889e-06 31.3194L0 7.12427Z" fill="#594EBF"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3184 19.5913V27.6197C15.4216 26.3799 17.4275 25.541 19.7211 25.541H22.2134V34.8738C22.2134 37.3567 21.5354 39.788 20.5295 40.9834H31.3709C30.3672 39.7868 29.6908 37.3585 29.6908 34.8786V25.541H32.1833C34.4767 25.541 36.4826 26.3799 37.5858 27.6197V19.5913H14.3184Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_1756_2012">
        <rect width="51.9043" height="60.555" fill="white"/>
      </clipPath>
    </defs>
  </svg>


</template>

<style scoped lang="less">

</style>
